/*globals $, sessionZip, sessionState */

var callouts = {
        "olo": "oloCallout",
        "patriots": "patriotsWinCallout",
        "bfastAW": "breakfast50AWCallout",
        "bfastMF": "breakfast50MFCallout",
        "kids50Pc": "justForKidsCallout",
        "tuesday2dollar": "tuesday2DollarCallout",
        "friendlyerPrices": "spendLessSmileMoreCallout",
    },
    oloZips = ["01001", "01501", "01028", "01238", "01069", "01570", "01085", "06109", "06226", "01075", "02719", "01604", "07950", "01040", "07066", "01824", "02188", "07642", "02180", "06360", "01056", "07003", "07961", "03103", "01520", "12061", "05201", "19067", "01701", "03301", "01566", "02170", "02339", "02190", "19020", "06082", "03431", "03867", "07840", "19034", "05701", "02452", "02767", "01960", "19047", "01108", "06066", "02062", "02601", "02562", "06705", "17033", "06010", "06096", "08753", "01301", "02777", "01020", "03860", "01830", "01129", "12804", "12901", "02472", "01089", "02747", "12065", "23831", "01201", "03246", "12095", "02904", "01843", "01906", "19401", "19020", "06489", "18702", "06355", "03820", "06416", "17325", "02771", "03301", "12180", "06106", "04330", "02359", "03060", "01085", "01930", "08753", "04106", "01913", "05495", "02540", "06040", "02346", "06088", "02703", "06111", "04062", "06460", "06062", "02093", "12866", "01757", "02360", "06473", "03054", "18512", "17821", "06770", "06810", "06488", "06001", "21061", "19901", "21061", "21122", "18372", "17601", "17601", "08054", "18301", "17111", "14616", "14606", "13206", "13126", "14456", "13214", "14626", "14850", "13045", "13041", "13905", "13790", "13760", "14845", "13820", "13601", "13413", "13090", "14564", "08043", "08012", "34986", "11730", "11501", "11779", "11010", "11554", "11510", "11782", "11789", "11791", "11725", "11756", "11901", "11764", "11787", "11727", "11763", "11953", "11762", "11967", "18103", "18087", "18042", "19607", "32819", "32937", "08857", "08840", "08053", "07860", "07461", "21742", "14701", "14760", "14219", "14226", "14221"],
    deliveryZips = [],
    testZips = {
        "olo": "14221",
        "patriots": "06810",
        "delivery": "17011",
        "bfastAW": "19128",
        "bfastMF": "19128",
        "tuesday2dollar": "06810"
    };

$(document).ready(function () {
    detectUserLocation();
});

function checkZip(zip) {
    "use strict";
    return (sessionZip !== undefined && sessionZip !== "") ? sessionZip : "";
}

function checkState() {
    "use strict";
    return (sessionState !== undefined && sessionState !== "") ? sessionState : "";
}

// Detect user's location & show correct messaging
// Callback set in map_current_location shortcode
function detectUserLocation() {
    "use strict";

    var location = {
        "zip": sessionZip,
        "state": sessionState
    };

    // if (location.zip !== "" && location.zip !== 0 && location.zip !== "0") {
    //     if ($("#locateBlockInput").exists()) {
    //         $("#locateBlockInput").val(location.zip);
    //     }
    //     if ($("#locateSearch").exists()) {
    //         $("#locateSearch").val(location.zip);
    //     }
    // }

    // if ($("#pageHome").exists()) {
    //     if (location.zip !== "" || location.state !== "") {
    //         displayHomepageCallout(location);
    //         displayHomepageMarquee(location);
    //     } else {
    //         setMarquee(callouts.kids50Pc);
    //     }
    // }

    // if ($("#pageMenu").exists()) {
    //     setRestaurantMenu(zip);
    // }
    
    // if ($("#pageOffers").exists()) {
    //     setOfferList(zip);
    // }
    
    // if ($(".single-menu-item").exists()) {
    //     setSingleProductSubcategory(zip);
    // }
}

function displayHomepageCallout(location) {
    "use strict";

    var zip = location.zip;

    $.when(
        getRestaurantList(63660) // a1: $2 Tuesdays
    ).done(function (a1) {
        if (a1.zips.includes(zip)) {
            setMarquee(callouts.tuesday2dollar);
        } else if (oloZips.includes(zip)) {
            setMarquee(callouts.olo);
        }
    });
}

function displayHomepageMarquee(location) {
    "use strict";

    var state = location.state,
        zip = location.zip,
        i = 0;

    $.when(
        getRestaurantList(63679), // a1: Patriots offer
        getRestaurantList(61264), // a2: 50% Breakfast Mon - Sun
        getRestaurantList(14380), // a3: 50% Breakfast Mon - Fri
        getRestaurantList(63665), // a4: 50% Kids Meal
        getRestaurantList(64363)  // a5: Friendlyer Prices
    ).done(function (a1, a2, a3, a4, a5) {
        if (a1.states.includes(state)) {
            setMarquee(callouts.patriots);
            
            if (a5.zips.includes(zip)) {
                setMarquee(callouts.friendlyerPrices);
            }
        } else {
            MAPBASE.getDeliveryNear(zip).done(function (promise) {
                promise.done(function (result) {
                    deliveryZips = [];
                    for (i; i < result.length; i++) {
                        deliveryZips.push(result[i].zip);
                    }

                    if (deliveryZips.length > 0 && deliveryZips.includes(zip)) {
                        setDeliveryCallout(result[0]);
                        
                        if (a5.zips.includes(zip)) {
                            setMarquee(callouts.friendlyerPrices);
                        }
                    } else if (a5.zips.includes(zip)) {
                        setMarquee(callouts.friendlyerPrices);
                    } else if (a4.zips.includes(zip)) {
                        setMarquee(callouts.kids50Pc);
                    }
                });
            }).fail(function (err) {
                if (a5.zips.includes(zip)) {
                    setMarquee(callouts.friendlyerPrices);
                } else if (a4.zips.includes(zip)) {
                    setMarquee(callouts.kids50Pc);
                }
                console.log("Delivery list get error.");
            });
        }
    });
}

function setRestaurantMenu(location) {
    "use strict";

    var postId = getPostId(),
        locationZip = location || 0;

    $.ajax({
        type: "post",
        url: ajaxUrl,
        dataType: "html",
        data: {
            "action": "get_restaurant_menu",
            "postid": postId,
            "zipcode": locationZip
        },
        success: function (response) {
            $("#menuSection").html(response);
            $.each($("[data-accordion]"), function () {
                ACCORDIONS.push(new Accordion($(this)));
            });

            setTimeout(function () {
                if (window.location.hash) {
                    $("html, body").animate({
                        scrollTop: $(window.location.hash).offset().top
                    }, 1000);
                }
            }, 1000);
        }
    });
}

function setOfferList(location) {
    "use strict";

    var locationZip = location || 0;

    $.ajax({
        type: "post",
        url: ajaxUrl,
        dataType: "html",
        data: {
            "action": "get_restaurant_offers",
            "zipcode": locationZip
        },
        success: function (response) {
            $("#offersSection").html(response);
            $.each($("[data-accordion]"), function () {
                ACCORDIONS.push(new Accordion($(this)));
            });

            setTimeout(function () {
                if (window.location.hash) {
                    $("html, body").animate({
                        scrollTop: $(window.location.hash).offset().top
                    }, 1000);
                }
            }, 1000);
        }
    });
}

function setSingleProductSubcategory(location) {
    "use strict";

    var postId = getPostId(),
        locationZip = location || 0;

    $.ajax({
        type: "post",
        url: ajaxUrl,
        dataType: "html",
        data: {
            "action": "get_single_product_subcategory",
            "postid": postId,
            "zipcode": locationZip
        },
        success: function (response) {
            $("#singleProductSubcategorySection").html(response);
            $.each($("[data-accordion]"), function () {
                ACCORDIONS.push(new Accordion($(this)));
            });
        }
    });
}

function setMarquee(id) {
    "use strict";

    var node = $("#" + id);

    node.removeClass("hide");

    if (window.location.hash === "#" + id) {
        $("html, body").animate({
            scrollTop: node.offset().top - 100
        }, 1000);
    }
}

function getRestaurantList(request, type) {
    "use strict";

    if (!type) {
        type = "offer";
    }

    return $.ajax({
        type: "post",
        url: ajaxUrl,
        dataType: "json",
        data: {
            "action": "get_restaurants_for_" + type,
            "request": request
        }
    }).then(function (result) {
        if (result.success === true) {
            return result.response;
        } else {
            return false;
        }
    });
}

function setDeliveryCallout(location) {
    "use strict";

    var callout = $("#weDeliverCallout"),
        oloLink;

    if (callout.exists()) {
        oloLink = location.online_ordering_url;
        callout.find("[data-delivery-city]").attr("href", location.link);
        callout.find("[data-delivery-city]").append("<span> " + location.city + "</span>");
        callout.find(".cta-btn").attr("href", oloLink);
        callout.removeClass("hide");
    }
}